export default {
  FOOTER_COPYRIGHT: 'copywright in footer',
  NEXT: 'Next',
  BACK: 'Back',
  BEGIN: 'Begin',
};
